<template>
    <el-menu class="left-sidebar-menu" @select="handleSelect" :default-active="$route.path">
        <el-menu-item index="/abroad/account/companyInfo">
            <i class="el-icon-menu company-info"></i>
            <span slot="title">{{ $t("title.companyInfo")}}</span>
        </el-menu-item>
        <!-- <el-menu-item index="/abroad/ad/list">
            <i class="el-icon-document payment-info"></i>
            <span slot="title">{{ $t("title.paymentInfo")}}</span>
        </el-menu-item> -->
  </el-menu>
</template>
<script>
    export default {
        methods: {
           handleSelect(key, keyPath) {
                return this.$router.push(key)
           },
        }
    }
</script>

<style>
.el-menu-item .company-info.el-icon-menu:before{
    content:'';
    display: inline-block;
    width:15px;
    height: 15px;
    background:url(../../../../../assets/img/account.png);
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    vertical-align: bottom;
}
.el-menu-item.is-active .company-info.el-icon-menu:before{
    content:'';
    display: inline-block;
    width:15px;
    height: 15px;
    background:url(../../../../../assets/img/account.png);
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    vertical-align: bottom;
}
.el-menu-item .payment-info.el-icon-document:before{
    content:'';
    display: inline-block;
    width:15px;
    height: 15px;
    background:url(../../../../../assets/img/account.png);
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    vertical-align: bottom;
}
.el-menu-item.is-active .payment-info.el-icon-document:before{
    content:'';
    display: inline-block;
    width:15px;
    height: 15px;
    background:url(../../../../../assets/img/account.png);
    background-size: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    vertical-align: bottom;
}

</style>
